import { Routes } from '@angular/router';
import { PermissionGuard } from './core/guards/permission/permission.guard';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { environment } from '@env/environment';
import { ViewHotelApprovalReviewComponent } from '@modules/ota/hotel-ota/components/hotel-approval-review/view-hotel-approval-review/view-hotel-approval-review.component';
import { ViewHotelApprovalReviewComponent as ViewHotelApprovalReviewComponentV2  } from '@modules/ota-v2/hotel-ota/components/hotel-approval-review/view-hotel-approval-review/view-hotel-approval-review.component';
import { HotelReviewApprovalRatingComponent } from '@modules/hotel-booking/components/detail/hotel-review-approval-rating/hotel-review-approval-rating.component';
import { ViewTermsAndConditionsComponent } from '@modules/ota/hotel-ota/components/terms-and-conditions/view-terms-and-conditions/view-terms-and-conditions.component';
import { ViewHotelLegalityReviewComponent } from '@modules/ota/hotel-ota/components/hotel-legality-review/view-hotel-legality-review/view-hotel-legality-review.component';
import { AdminSupportAgencyComponent } from '@modules/ota/hotel-ota/components/hotel-management/admin-support-agency/admin-support-agency.component';
import { HotelLinkIntrustionComponent } from '@shared/components/hotel-link-intrustion/hotel-link-intrustion.component';
import { CreatePropertyComponent } from '@shared/components/create-property/create-property.component';
import { ViewHotelLegalityReviewComponent as ViewHotelLegalityReviewComponentV2 } from '@modules/ota-v2/hotel-ota/components/hotel-legality-review/view-hotel-legality-review/view-hotel-legality-review.component';


export const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'booking',
    pathMatch: 'full',
  },
  {
    path: 'booking',
    loadChildren: () =>
      import('@modules/booking/booking.routes').then(
        ({ BOOKING_ROUTES }) => BOOKING_ROUTES
      ),
  },
  {
    path: 'common/icon',
    loadComponent: () =>
      import('./modules/common/icon/icon.component').then(
        ({ IconComponent }) => IconComponent
      ),
    title: 'Booking: Icon',
  },
  {
    path: 'common/upload-files',
    loadComponent: () =>
      import('./modules/common/upload-files/upload-files.component').then(
        ({ UploadFilesComponent }) => UploadFilesComponent
      ),
    title: 'Booking: Upload files',
  },
  {
    path: 'my-booking',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/my-booking/my-bookings.routes').then(
        ({ MY_BOOKING_ROUTES }) => MY_BOOKING_ROUTES
      ),
  },
  {
    path: 'ota',
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      roles: ['USER'],
    },
    loadChildren: () =>
      import('./modules/ota/ota.routes').then(({ OTA_ROUTES }) => OTA_ROUTES),
  },
  {
    path: 'ota-v2',
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      roles: ['USER'],
    },
    loadChildren: () =>
      import('./modules/ota-v2/ota.routes').then(({ OTA_ROUTES }) => OTA_ROUTES),
  },
  {
    path: 'admin-support',
    component: AdminSupportAgencyComponent,
  },
  {
    path: 'ota/channel-manager/hotel-link-instruction.html',
    canActivate: [AuthGuard],
    component: HotelLinkIntrustionComponent
  },
  {
    path: 'mobile/general/create-property.html',
    component: CreatePropertyComponent
  },
  {
    path: 'hotel-agency/:property_id/approval-review',
    component: ViewHotelApprovalReviewComponent,
  },
  {
    path: 'hotel-agency-v2/:property_id/approval-review',
    component: ViewHotelApprovalReviewComponentV2,
  },
  {
    path: 'hotel-agency-legality/:property_id/approval-review',
    component: ViewHotelLegalityReviewComponent,
  },
  {
    path: 'hotel-agency-legality-v2/:property_id/approval-review',
    component: ViewHotelLegalityReviewComponentV2,
  },
  {
    path: 'ota/hotel-ota/terms-and-conditions',
    component: ViewTermsAndConditionsComponent,
  },
  {
    path: 'hotel-review/:rating_id/approval-rating',
    component: HotelReviewApprovalRatingComponent,
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./modules/users/components/sign-in/sign-in.component').then(
        ({ SignInComponent }) => SignInComponent
      ),
    title: environment.PRODUCT_NAME + ': Sign In',
  },
  {
    path: 'sign-up',
    loadComponent: () =>
      import('./modules/users/components/sign-up/sign-up.component').then(
        ({ SignUpComponent }) => SignUpComponent
      ),
    title: environment.PRODUCT_NAME + ': Sign Up',
  },
  {
    path: 'common/version',
    loadComponent: () =>
      import('./modules/common/version/version.component').then(
        ({ VersionComponent }) => VersionComponent
      ),
    title: 'checking version',
  },
  {
    path: 'server-error/:type-error',
    loadComponent: () =>
      import('./layout/server-error-page/server-error-page.component').then(
        ({ ServerErrorPageComponent }) => ServerErrorPageComponent
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./layout/page-not-found/page-not-found.component').then(
        ({ PageNotFoundComponent }) => PageNotFoundComponent
      ),
    title: 'Page Not Found',
  },
];
